import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import { Box, Container, Image, Link, SimpleGrid } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async () => {
  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query {
        entries(collection: "partners", sort: "order") {
          data {
            ... on Entry_Partners_Partners {
              id
              website
              title
              logo {
                url
              }
            }
          }
        }
      }
    `
  )

  return {
    props: {
      partners: data.entries.data,
    },
    revalidate: 60,
  }
}

export const Page = ({ partners }: any) => {
  return (
    <>
      <Hero heading='Partners' />
      <Container maxWidth='7xl' py={20}>
        <SimpleGrid
          columns={{ base: 3, lg: 4, xl: 5 }}
          spacing={{ base: 8, lg: 20 }}>
          {partners.map((partner: any) =>
            partner.logo ? (
              <Box key={partner.id}>
                <Link
                  href={partner.website}
                  title={`Go to ${partner.title} website`}
                  target='_blank'>
                  <Image src={partner.logo.url} alt={partner.title} />
                </Link>
              </Box>
            ) : null
          )}
        </SimpleGrid>
      </Container>
    </>
  )
}

export default Page
